import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PollMenu from '../../../menus/PollMenu';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import { extConfig } from './config';

import presetViewerStyles from '../../../Viewer/presets/Poll/Poll.scss';
import s from './Poll.scss';

const PollEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  const { t } = useTranslation('editor');

  return (
    <div className={s['root']}>
      <div className={s['editor']}>
        <Editor
          {...props}
          withinModal
          presetId="poll"
          className={cn(s['root'], presetViewerStyles['root'])}
          extensionConfig={extConfig}
          initialContent={props.initialContent}
          placeholder={props.placeholder ?? t('preset.poll.placeholder')}
        ></Editor>
      </div>
      <div className={cn(s['toolbar'])}>
        <PollMenu />
      </div>
    </div>
  );
};
PollEditor.displayName = 'PollEditor';

export default PollEditor;
